import sha1 from 'crypto-js/sha1'
import sha256 from 'crypto-js/sha256'
import md5 from 'crypto-js/md5'
import consoleLogger from '../../../../../../modules/console-logger'
import handlerWindowDlab from '../../../../modules/handler-window-dlab'
import getCookieContent from '../../../../modules/get-cookie-content'

const liveRamp = ({ config }) => {
  const [consoleLog] = consoleLogger('AdsLog')
  const { dlabOption } = handlerWindowDlab('prebid', { sub: 'liveRamp' })
  if (dlabOption['isInitiated']) {
    return
  }
  let email = getCookieContent({ config, consoleLog })

  if (typeof config?.prepareEmailFunction === 'function') {
    email = config.prepareEmailFunction(email)
  }

  consoleLog('PREBID Liveramp - email', email, 'Ads')
  if (!email) {
    consoleLog('PREBID Liveramp - No email found.', 'Ads')
    return
  }

  window.addEventListener('envelopeModuleReady', function (event) {
    consoleLog('PREBID Liveramp - event', event, 'Ads')
    atsenvelopemodule.setAdditionalData({
      type: 'emailHashes',
      id: [sha1(email).toString(), sha256(email).toString(), md5(email).toString()],
    })
  })
  dlabOption['isInitiated'] = true
}

export default liveRamp
